module.exports = __webpack_public_path__ + "img/dsci0116.edbec199.jpg";